<template>
    <common-modal
        :showCloseIcon="false"
        width="huge"
        :heading="$t('forms.offer.create_offer.header')"
        @close="emitEvent({ name: 'close' })"
    >
        <form-wrapper @form-submit="submit">
            <form-row>
                <form-cell>
                    <text-input
                        :formData="data"
                        :label="$t('forms.offer.create_offer.fields.name.label')"
                        :placeholder="$t('forms.offer.create_offer.fields.name.placeholder')"
                        :isRequired="true"
                        type="text"
                        valuePath="title"
                        @change="change"
                    ></text-input>
                </form-cell>
            </form-row>

            <form-row>
                <form-cell width="half">
                    <select-input
                        :formData="data"
                        :label="$t('forms.offer.create_offer.fields.appointment_length.label')"
                        :placeholder="$t('forms.offer.create_offer.fields.appointment_length.placeholder')"
                        :isRequired="true"
                        :options="appointmentLengthOptions"
                        valuePath="appointmentLength"
                        @change="change"
                    ></select-input>
                </form-cell>
                <form-cell width="half">
                    <text-input
                        type="number"
                        :formData="data"
                        :label="`${$t('forms.offer.create_offer.fields.price.label')} (${prefill.currency}) `"
                        :placeholder="$t('forms.offer.create_offer.fields.price.placeholder')"
                        :isRequired="true"
                        valuePath="price"
                        @change="change"
                    ></text-input>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell>
                    <textarea-input
                        :formData="data"
                        :label="$t('forms.offer.create_offer.fields.description.label')"
                        :placeholder="$t('forms.offer.create_offer.fields.description.placeholder')"
                        :isRequired="true"
                        type="text"
                        :maxlength="600"
                        valuePath="description"
                        @change="change"
                    ></textarea-input>
                </form-cell>
            </form-row>
            <template #footer>
                <common-buttons>
                    <common-button
                        type="secondary"
                        :isSubmittable="false"
                        :isProcessing="false"
                        :label="$t('common.microcopy.back')"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button type="primary" :isProcessing="false" :label="$t('common.microcopy.save')"></common-button>
                </common-buttons>
            </template>
        </form-wrapper>
    </common-modal>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import PriceMixin from 'mixins/PriceMixin'
    import OfferAPI from 'api/OfferAPI'
    import CurrencyEnum from 'enums/currency.enum'
    import OfferTypeEnum from 'enums/offer_type.enum'
    import AppointmentLengthEnum from 'enums/appointment_length.enum'

    export default {
        mixins: [FormMixin, PriceMixin],
        props: {
            prefill: { type: Object, default: undefined },
            categoryId: { type: Number, default: undefined },
        },
        data: () => ({
            currencyOptions: Object.values(CurrencyEnum).map((currency) => ({ label: currency, value: currency })),
        }),
        computed: {
            appointmentLengthOptions() {
                return AppointmentLengthEnum[this.$i18n.locale].sort((a, b) => a.value - b.value)
            },
            offerType() {
                return this.isServiceForCompany ? OfferTypeEnum.COMPANY : OfferTypeEnum.USER
            },
            isServiceForCompany() {
                return !!this.prefill.location.companyServiceProvider
            },
        },
        methods: {
            submit() {
                const req = this.isServiceForCompany
                    ? this.data.id
                        ? OfferAPI.modifyCompanyOfferCategory
                        : OfferAPI.createCompanyOfferCategory
                    : this.data.id
                    ? OfferAPI.modifyUserOfferCategory
                    : OfferAPI.createUserOfferCategory
                const request = {
                    appointmentLength: Number(this.data.appointmentLength),
                    description: this.data.description,
                    price: Number(this.data.price),
                    title: this.data.title,
                    offerId: this.prefill.id,
                    id: this.categoryId,
                }
                if (this.isServiceForCompany) {
                    request.companyId = this.prefill?.location?.companyServiceProvider?.id
                }
                this.submitForm(req(request), { scrollTop: true })
                    .then(() => {
                        this.emitEvent({ name: 'offer-added' })
                    })
                    .catch((error) => {
                        const locationError = error?.error?.invalidFields.find(
                            (item) => item.message === 'IS_NUMBER' && item.field === 'locationId',
                        )
                        if (locationError) {
                            this.$toast.error(this.$t('common.errors.location_required'))
                        }
                    })
            },
        },
        mounted() {
            if (this.categoryId) {
                const category = this.prefill.offerCategories.find((item) => item.id === this.categoryId)
                category.price = this.setPrice(category[`price${this.prefill.currency}`])
                category.title = category?.titleTextContent?.originalText
                category.description = category?.descriptionTextContent?.originalText

                this.prefillData(category)
            }
        },
    }
</script>
